import { CustomTable } from 'components/CustomTable';
import { FC } from 'react';
import { Link } from 'components/Link';
import { IUserStripeSubscriptionData } from 'store/userStripeSubscriptions/types';
import {
  getColumnsStripeRecurring,
  getColumnsStripeRecurringMobile,
  getIsSubscriptionActive,
} from '../utils';

interface Props {
  subscriptions: Array<IUserStripeSubscriptionData>;
}

export const StripeRecurringDonations: FC<Props> = ({ subscriptions }) => {
  const formattedSubscriptions = subscriptions.map(subscription => ({
    ...subscription,
    className: getIsSubscriptionActive(subscription) ? '' : 'disabled',
  }));

  return (
    <>
      <CustomTable
        hideForSmall={true}
        columns={getColumnsStripeRecurring()}
        data={formattedSubscriptions}
      />
      <CustomTable
        hideForLarge={true}
        columns={getColumnsStripeRecurringMobile()}
        data={formattedSubscriptions}
      />
      <div className="display-flex">
        <div className="full-width mt16">
          <span className="body-small-text color-black">
            If you would like to modify your recurring donations, please email{' '}
            <Link href="mailto:monthly@oath.vote" $fontSize="inherit">
              monthly@oath.vote
            </Link>
            .
          </span>
        </div>
      </div>
    </>
  );
};
